module.exports = new __parcel__URL__("yellow-shopping-basket.69e8f8e3.png").toString();